module.exports = __webpack_public_path__ + "static/media/img55.4a9265f2.jpg";